import ReduxableService from './parentСlasses/ReduxableService'

import { setGeozone } from '../actions/service';
import * as actions from '../actions/geozone';

import { checkColor } from '../tools';


export default class GeozoneService extends ReduxableService {


  constructor(store) {
    super(store, actions, setGeozone)
  }
  /**сохряняет полигон геозоны */
  saveGeozonePolygone = (id, poly) => {
    this.rr.service_Api.saveGeoObjGeozone({ id, polygon: poly })
  }
  /**обновляет полигон в геозоне */
  updateGeozonePolygone = (id, poly) => {
    const updatedPoly = this.rr.geozone_geozoneArr.map((item) => (item?.id === id ? { ...item, polygon: poly } : item))
    this.actions.setGeozoneArr(updatedPoly)
  }
  /**Обновляет прочие настройки геозон */
  updateGeozoneAtribute = (id, newGeozoneObj) => {
    const updatedPoly = this.rr.geozone_geozoneArr.map((item) => (item?.id === id ? { ...item, ...newGeozoneObj } : item))
    this.actions.setGeozoneArr(updatedPoly)
  }
  /**Обновляет настроечный массив геозоны */
  updateGeozoneSettingsArr = (settingsArr) => {
    this.actions.setGeozoneSettingsArr(settingsArr)
  }
  /**Инициирует загрузку геозон */
  loadGeozone = () => {
    this.rr.service_Api.getGeoObjGeozone();
  }
  /**создаем массив геозон и массив настроек показа геозон */
  addGeoArr = (geozoneArr, activate = false) => {
    this.actions.setGeozoneArr(geozoneArr.map(this._zoneColorizer))
    this.actions.setGeozoneSettingsArr(geozoneArr.map(() => ({ active: activate })))
  }
  //Группа ф-ций относящаяся к рисованию новых полигонов
  /**Сбросить что нарисовали */
  resetVertex=()=>{
    this.actions.setGeozoneVertexArr()
  }
  /**Удалить последнюю вершину */
  deleteLastVertex=()=>{
    const { geozoneVertexArr=[] } = this.rr._geozone;
    if(!geozoneVertexArr?.length) return;
    this.actions.setGeozoneVertexArr(geozoneVertexArr.slice(0,-1))
  }
  /**Добавить вершину */
  addVertex=(x,y)=>{
    const { geozoneVertexArr=[] } = this.rr._geozone;
    this.actions.setGeozoneVertexArr([...geozoneVertexArr, {x,y}])
  }
  //внутренние функции
  _storeListener = () => {

    if (this._isChange('api_geoObjGeozone')) {
      const { loading, data, error } = this.rr.api_geoObjGeozone || {}

      if (!loading) {
        if (!error && data?.length) {
          //Что-то делаем с геозоной
          this.addGeoArr(data)
        }
      }
    }
    if (this._isChange('api_savingGeoObjGeozone')) {
      const { loading, data, error } = this.rr.api_savingGeoObjGeozone || {}
      if (!loading) {
        if (!error && data?.fields?.id ) {
          //Обновляем геозону в массиве
          this.updateGeozoneAtribute(data.fields.id, this._zoneColorizer(data.fields))
          //очицаем сохраненный полигон
          this.resetVertex()
        }
      }
    }
  }
  /**Служебный байпасс, гарантирует, что пройдя через него в геозоне будет корректный цвет */
  _zoneColorizer=(zone) => (checkColor(zone.color) ? zone : { ...zone, color: '#fac' })

}
